import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import { useTitleRampNamesExist } from '../shared/useTitleRampNames';
export var TableHeaderBase = function () {
    var exists = useTitleRampNamesExist('TitleCellContent', 'HeaderTitleCellContent', 'HeaderHorizontalWrapperCornerTitleContent');
    return exists ? (React.createElement(RampWithNameTransform, { rampName: "HeaderContainer" },
        React.createElement(RampWithNameTransform, { rampName: "HeaderContent" }))) : null;
};
